/* ═══════════════════════════════════════════════════
   BUNDLE BUILDER — Cart Drawer Progress Bar JS
   Shows/hides a tier-based progress bar in the cart
   drawer based on eligible products in cart.

   NOTE — Discount application:
   Discounts are handled by a Shopify Discount Function
   (Shopify Functions API) that reads the _bundle_item
   and _bundle_id line-item properties set by
   bundle-builder-page.js. The Function groups items by
   _bundle_id, counts total quantity, and applies the
   correct tier percentage at checkout.
   No client-side discount code redirect needed here.
═══════════════════════════════════════════════════ */
(function initBundleBuilderCart() {
  'use strict';

  var bbBlock = document.getElementById('bbCartUpsell');
  if (!bbBlock) return;

  /* ─────────────────────────────────────────────────
     ELIGIBLE PRODUCTS
  ───────────────────────────────────────────────── */
  var eligibleIds = [];
  var rawIds = (bbBlock.getAttribute('data-eligible-product-ids') || '').trim();
  if (rawIds) {
    eligibleIds = rawIds.split(',').map(function(id) { return id.trim(); }).filter(function(id) { return id && id !== '0'; });
  }

  var eligibleHandles = [];
  var rawHandles = (bbBlock.getAttribute('data-eligible-product-handles') || '').trim();
  if (rawHandles) {
    eligibleHandles = rawHandles.split(',').map(function(h) { return h.trim(); }).filter(Boolean);
  }

  var hasConfig = eligibleIds.length > 0 || eligibleHandles.length > 0;

  function isEligible(item) {
    if (eligibleIds.length && eligibleIds.some(function(id) { return String(item.product_id) === id; })) return true;
    if (eligibleHandles.length && item.handle && eligibleHandles.some(function(h) { return item.handle === h; })) return true;
    if (!hasConfig) return true;
    return false;
  }

  /* A cart item only counts as part of the bundle if it was explicitly added
     through the bundle builder page — identified by the _bundle_item line
     property set by bundle-builder-page.js.
     Products that happen to be "eligible" but were added from other pages
     (PDP, recommendations, etc.) must NOT be counted or grouped. */
  function isBundleItem(item) {
    if (!item.properties) return false;
    return item.properties['_bundle_item'] === 'true' || item.properties['_bundle_item'] === true;
  }

  /* ─────────────────────────────────────────────────
     TIERS
  ───────────────────────────────────────────────── */
  var tiers = [];
  try {
    var rawTiers = JSON.parse(bbBlock.getAttribute('data-tiers') || '[]');
    tiers = rawTiers
      .filter(function(t) { return t.qty > 0; })
      .sort(function(a, b) { return a.qty - b.qty; });
  } catch(e) { tiers = []; }
  if (!tiers.length) {
    tiers = [
      { qty: 2, pct: 15, label: '2 products – 15% off' },
      { qty: 3, pct: 20, label: '3 products – 20% off' },
      { qty: 4, pct: 25, label: '4 products – 25% off' }
    ];
  }

  var maxQty = tiers[tiers.length - 1].qty;

  function getActiveTier(qty) {
    var active = null;
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (qty >= tiers[i].qty) { active = tiers[i]; break; }
    }
    return active;
  }

  /* ─────────────────────────────────────────────────
     PROGRESS BAR
  ───────────────────────────────────────────────── */
  function updateProgressBar(eligibleQty) {
    var fillBar    = bbBlock.querySelector('[data-bb-fill]');
    var nextGrid   = bbBlock.querySelector('[data-bb-next-grid]');
    var nextText   = bbBlock.querySelector('[data-bb-next-text]');
    var unlockedEl = bbBlock.querySelector('[data-bb-unlocked-text]');
    var counterEl  = bbBlock.querySelector('[data-bb-counter]');
    var tierLabels = bbBlock.querySelectorAll('[data-bb-tier-label]');

    var fillPct = Math.min(Math.round((eligibleQty / maxQty) * 100), 100);
    var clipPct = 100 - fillPct;

    if (fillBar)  fillBar.style.width = fillPct + '%';
    if (nextGrid) nextGrid.style.clipPath = 'inset(0px ' + clipPct + '% 0px 0px)';
    if (counterEl) counterEl.textContent = '(' + eligibleQty + '/' + maxQty + ')';

    var unlockedTier = getActiveTier(eligibleQty);
    if (unlockedEl) {
      unlockedEl.textContent = unlockedTier ? unlockedTier.pct + '% off unlocked!' : '';
    }

    var nextTier = null;
    for (var j = 0; j < tiers.length; j++) {
      if (tiers[j].qty > eligibleQty) { nextTier = tiers[j]; break; }
    }
    if (nextText) {
      if (nextTier) {
        var need = nextTier.qty - eligibleQty;
        nextText.textContent = 'Add ' + need + ' more for ' + nextTier.pct + '% off';
      } else {
        nextText.textContent = 'Max discount unlocked! 🎉';
      }
    }

    tierLabels.forEach(function(lbl) {
      var tierQty = parseInt(lbl.getAttribute('data-tier-qty') || '0', 10);
      lbl.classList.toggle('is-active', unlockedTier !== null && tierQty <= eligibleQty);
    });
  }

  /* ─────────────────────────────────────────────────
     BUNDLE GROUP CARD
     The card lives in #bb-group-card-anchor — a sibling
     div inserted in cart-drawer.liquid right after
     [data-products]. Motion only ever replaces the
     contents of [data-products], so it NEVER touches
     the anchor and the card is never destroyed.

     groupBundleItems:
     - Reads bundle items from .cart__items (DOM)
     - If card content unchanged → just re-hides source rows
     - If changed → patches card text + carousel in-place
     - If no bundle items → removes the card
     - Source .cart__item rows are hidden with display:none
  ───────────────────────────────────────────────── */

  var savedCardKey = null;

  /* Keys (cart line item keys) of the current bundle items,
     populated on every fetchCartAndSync so removeBundle always
     has fresh data and never relies on the DOM. */
  var bundleLineKeys = [];

  /* ── Remove entire bundle from cart ── */
  var removeBundleInFlight = false;

  function removeBundle() {
    if (!bundleLineKeys.length) return;
    if (removeBundleInFlight) return; // already in progress — ignore extra clicks
    removeBundleInFlight = true;

    var keysToRemove = bundleLineKeys.slice(); // snapshot before clearing
    var updates = {};
    keysToRemove.forEach(function(k) { updates[k] = 0; });

    // Disable the X button to prevent double-clicks — do NOT touch the card.
    var btn = document.querySelector('.bb-group-card__remove-btn');
    if (btn) { btn.disabled = true; btn.style.opacity = '0.4'; }

    // Cloak [data-products] RIGHT NOW so any re-render that happens during the
    // API round-trip never shows the bundle rows as individual items.
    // The card itself stays visible until the API confirms success.
    var productsEl = document.querySelector('[data-products]');
    if (productsEl) {
      productsEl.classList.add('bb-cloaked');
      setTimeout(function() { productsEl.classList.remove('bb-cloaked'); }, 4000);
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('update failed');
      // No need to fetch /cart.js here — the MutationObserver triggered by
      // Motion's buildCart() will call fetchCartAndSync() which fetches it.
      return r.json();
    })
    .then(function() {
      removeBundleInFlight = false;
      bundleLineKeys = [];
      savedCardKey = null;

      // Only dispatch ajaxProduct:added — Motion's buildCart() will re-render
      // the drawer, which triggers our MutationObserver → single fetchCartAndSync.
      // No need for cart:updated here (Motion dispatches its own after buildCart,
      // and we no longer listen for it anyway).
      var cartForm = document.querySelector('#CartDrawerForm') || document.body;
      cartForm.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
    })
    .catch(function() {
      removeBundleInFlight = false;
      if (btn) { btn.disabled = false; btn.style.opacity = ''; }
      if (productsEl) productsEl.classList.remove('bb-cloaked');
      fetchCartAndSync();
    });
  }

  /* ── Remove a single bundle line item from cart ── */
  var removeLineItemInFlight = false;

  function removeLineItem(key) {
    if (!key) return;
    if (removeLineItemInFlight) return;
    removeLineItemInFlight = true;

    // Optimistically disable the clicked button
    var btn = document.querySelector('.bb-group-card__slide-remove[data-key="' + key + '"]');
    if (btn) { btn.disabled = true; btn.style.opacity = '0.4'; }

    // Cloak immediately to prevent flash
    var productsEl = document.querySelector('[data-products]');
    if (productsEl) {
      productsEl.classList.add('bb-cloaked');
      setTimeout(function() { productsEl.classList.remove('bb-cloaked'); }, 4000);
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: { [key]: 0 } })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('update failed');
      return r.json();
    })
    .then(function() {
      removeLineItemInFlight = false;
      bundleLineKeys = bundleLineKeys.filter(function(k) { return k !== key; });
      savedCardKey = null;
      var cartForm = document.querySelector('#CartDrawerForm') || document.body;
      cartForm.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
    })
    .catch(function() {
      removeLineItemInFlight = false;
      if (btn) { btn.disabled = false; btn.style.opacity = ''; }
      if (productsEl) productsEl.classList.remove('bb-cloaked');
      fetchCartAndSync();
    });
  }

  function buildSlidesHTML(bundleItems) {
    var slides = [];
    bundleItems.forEach(function(item) {
      var imgHTML = item.imgSrc
        ? '<img src="' + item.imgSrc + '" alt="' + item.title.replace(/"/g, '&quot;') + '" width="72" height="72" loading="lazy">'
        : '<div class="bb-group-card__img-placeholder"></div>';
      var slideHTML = (
        '<div class="bb-group-card__slide">' +
          '<div class="bb-group-card__img-wrap">' +
            imgHTML +
            '<button type="button" class="bb-group-card__slide-remove" data-key="' + item.key + '" aria-label="Remove ' + item.title.replace(/"/g, '&quot;') + '">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="1" y1="1" x2="9" y2="9"/><line x1="9" y1="1" x2="1" y2="9"/></svg>' +
            '</button>' +
          '</div>' +
          '<span class="bb-group-card__name">' + item.title + '</span>' +
        '</div>'
      );
      // Expand duplicates: qty=2 → 2 individual slides, each with the same key
      for (var i = 0; i < item.qty; i++) {
        slides.push(slideHTML);
      }
    });
    return slides.join('');
  }

  function bindSlideRemoveButtons(carousel) {
    carousel.querySelectorAll('.bb-group-card__slide-remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var key = btn.getAttribute('data-key');
        removeLineItem(key);
      });
    });
  }

  function groupBundleItems(bundleCartItems) {
    var anchor = document.getElementById('bb-group-card-anchor');
    var productsContainer = document.querySelector('[data-products]');
    if (!anchor || !productsContainer) return;

    var itemsContainer = productsContainer.querySelector('.cart__items') || productsContainer;

    // Helper: remove the visibility cloak once we've finished processing
    function uncloak() {
      productsContainer.classList.remove('bb-cloaked');
    }

    isGroupingItems = true;

    // ── PHASE 1: UNHIDE previously hidden rows (Motion may have re-rendered them) ──
    itemsContainer.querySelectorAll('.cart__item[data-bb-hidden]').forEach(function(el) {
      el.removeAttribute('data-bb-hidden');
      el.style.display = '';
    });

    // ── PHASE 2: MATCH API bundle items to DOM rows ────────────────────────────────
    // bundleCartItems comes from /cart.js — only items with _bundle_item property.
    // We match each to its DOM row via data-key (Motion renders this attribute).
    var bundleItems = [];
    if (bundleCartItems && bundleCartItems.length) {
      bundleCartItems.forEach(function(apiItem) {
        // Find the corresponding DOM row by its key attribute
        var node = itemsContainer.querySelector('.cart__item[data-key="' + apiItem.key + '"]');

        var imgSrc = apiItem.featured_image && apiItem.featured_image.url
          ? apiItem.featured_image.url : '';
        if (!imgSrc && node) {
          // Fallback: read from rendered <img>
          var imgEl = node.querySelector('img');
          imgSrc = imgEl ? (imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || '') : '';
        }
        if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
        if (imgSrc) {
          imgSrc = imgSrc.replace(/(_\d+x\d*|_\d*x\d+)(\.[a-z]+(\?|$))/i, '$2');
          imgSrc = imgSrc.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2');
        }

        bundleItems.push({
          node:   node,   // may be null if DOM hasn't re-rendered yet
          key:    apiItem.key,
          title:  apiItem.product_title || apiItem.title || '',
          imgSrc: imgSrc,
          qty:    apiItem.quantity
        });
      });
    }

    // ── PHASE 2.5: RETRY if DOM nodes haven't rendered yet ──────────────────────
    // Motion renders cart items async. If any expected node is missing, release
    // the lock immediately (so the MutationObserver can fire when Motion paints)
    // and return — the MutationObserver will trigger fetchCartAndSync once
    // Motion finishes buildCart(), which will call groupBundleItems again.
    // No explicit retry timers needed; that caused redundant /cart.js fetches.
    var missingNodes = bundleItems.length > 0 && bundleItems.some(function(it) { return !it.node; });
    if (missingNodes) {
      isGroupingItems = false;
      // Keep the cloak on — Motion hasn't finished painting yet.
      return;
    }

    // ── PHASE 3: DECIDE ───────────────────────────────
    var existingCard = anchor.querySelector('.bb-group-card');

    if (!bundleItems.length) {
      if (existingCard) existingCard.remove();
      savedCardKey = null;
      uncloak();
      requestAnimationFrame(function() { requestAnimationFrame(function() { isGroupingItems = false; }); });
      return;
    }

    var totalQty    = bundleItems.reduce(function(sum, it) { return sum + it.qty; }, 0);
    var activeTier  = getActiveTier(totalQty);
    var tierPct     = activeTier ? activeTier.pct : 0;
    var hasSubscription = bundleCartItems.some(function(it) {
      return it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
    });
    var fingerprint = bundleItems.map(function(it) { return it.key + ':' + it.qty; }).join('|') + '@' + tierPct + (hasSubscription ? '+sub' : '');

    // ── PHASE 4: COMMIT ───────────────────────────────
    if (!existingCard) {
      existingCard = document.createElement('div');
      existingCard.className = 'bb-group-card';
      existingCard.innerHTML =
        '<div class="bb-group-card__header">' +
          '<span class="bb-group-card__title"></span>' +
          '<span class="bb-group-card__tier-label"></span>' +
          '<span class="bb-group-card__sub-badge" style="display:none">' +
            '<svg class="bb-group-card__sub-icon" width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M11.5 1C11.776 1 12 1.224 12 1.5V2.5H13C14.105 2.5 15 3.395 15 4.5V13C15 14.105 14.105 15 13 15H3C1.895 15 1 14.105 1 13V4.5C1 3.395 1.895 2.5 3 2.5H4V1.5C4 1.224 4.224 1 4.5 1C4.776 1 5 1.224 5 1.5V2.5H11V1.5C11 1.224 11.224 1 11.5 1ZM2 6.5V13C2 13.552 2.448 14 3 14H13C13.552 14 14 13.552 14 13V6.5H2ZM3 3.5C2.448 3.5 2 3.948 2 4.5V5.5H14V4.5C14 3.948 13.552 3.5 13 3.5H3Z" fill="currentColor"/></svg>' +
            'Subscription' +
          '</span>' +
          '<button type="button" class="bb-group-card__remove-btn" aria-label="Remove bundle" title="Remove all bundle items">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="1" y1="1" x2="13" y2="13"/><line x1="13" y1="1" x2="1" y2="13"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="bb-group-card__carousel" data-bb-carousel></div>';
      existingCard.querySelector('.bb-group-card__remove-btn').addEventListener('click', function(e) {
        e.stopPropagation();
        removeBundle();
      });
      anchor.appendChild(existingCard);
      initDragScroll(existingCard.querySelector('[data-bb-carousel]'));
    }

    if (savedCardKey !== fingerprint) {
      var titleEl2 = existingCard.querySelector('.bb-group-card__title');
      if (titleEl2) titleEl2.textContent = 'Bundle (' + totalQty + ' item' + (totalQty !== 1 ? 's' : '') + ')';
      var tierEl = existingCard.querySelector('.bb-group-card__tier-label');
      if (tierEl) tierEl.textContent = activeTier ? tierPct + '% off unlocked' : 'Bundle';
      var subBadge = existingCard.querySelector('.bb-group-card__sub-badge');
      if (subBadge) subBadge.style.display = hasSubscription ? '' : 'none';
      var carousel = existingCard.querySelector('[data-bb-carousel]');
      if (carousel) {
        carousel.innerHTML = buildSlidesHTML(bundleItems);
        bindSlideRemoveButtons(carousel);
        initDragScroll(carousel);
      }
      savedCardKey = fingerprint;
    }

    // ── PHASE 5: HIDE matched DOM rows ────────────────
    bundleItems.forEach(function(item) {
      if (!item.node) return;
      item.node.setAttribute('data-bb-hidden', '1');
      item.node.style.display = 'none';
    });

    // Rows are hidden — safe to reveal [data-products]
    uncloak();
    requestAnimationFrame(function() { requestAnimationFrame(function() { isGroupingItems = false; }); });
  }

  function initDragScroll(el) {
    if (!el) return;
    var isDown = false;
    var startX, scrollLeftStart;
    var canDrag = false;

    function updateCursor() {
      canDrag = el.scrollWidth > el.clientWidth;
      el.style.cursor = canDrag ? 'grab' : 'default';
    }
    updateCursor();
    if (window.ResizeObserver) {
      new ResizeObserver(updateCursor).observe(el);
    }

    el.addEventListener('mousedown', function(e) {
      if (!canDrag) return;
      if (e.button !== 0) return;
      isDown = true;
      startX = e.pageX;
      scrollLeftStart = el.scrollLeft;
      el.classList.add('is-grabbing');
      document.body.style.userSelect = 'none';
      document.body.style.webkitUserSelect = 'none';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      el.scrollLeft = scrollLeftStart - dx;
    });

    document.addEventListener('mouseup', function() {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('is-grabbing');
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
    });
  }

  /* ─────────────────────────────────────────────────
     SYNC
  ───────────────────────────────────────────────── */
  function updateBadgeLabels(eligibleQty) {
    var activeTier = getActiveTier(eligibleQty);
    document.querySelectorAll('[data-bb-item-badge]').forEach(function(badge) {
      var label = badge.querySelector('.bb-cart-item-badge__label');
      if (!label) return;
      label.textContent = activeTier ? 'Bundle – ' + activeTier.pct + '% off' : 'Bundle';
    });
  }

  function syncVisibility(cartItems) {
    if (!cartItems || !cartItems.length) {
      bbBlock.style.display = 'none';
      bundleLineKeys = [];
      isGroupingItems = false;
      groupBundleItems([]);
      return;
    }

    // Only items explicitly added through the bundle builder count
    var bundleItems = cartItems.filter(isBundleItem);
    var bundleQty   = bundleItems.reduce(function(sum, it) { return sum + it.quantity; }, 0);

    // Save keys for removeBundle — always fresh from the API response
    bundleLineKeys = bundleItems.map(function(it) { return it.key; });

    if (bundleQty < 1) {
      bbBlock.style.display = 'none';
      updateBadgeLabels(0);
      isGroupingItems = false;
      groupBundleItems([]);
      return;
    }
    updateProgressBar(bundleQty);
    updateBadgeLabels(bundleQty);
    bbBlock.style.display = '';
    groupBundleItems(bundleItems);
  }

  /* ─────────────────────────────────────────────────
     SYNC SCHEDULING
     fetchCartAndSync  — debounced /cart.js fetch
     (single entry point for all sync operations)
  ───────────────────────────────────────────────── */
  var isGroupingItems = false;
  var syncDebounceTimer = null;

  function fetchCartAndSync() {
    clearTimeout(syncDebounceTimer);
    syncDebounceTimer = setTimeout(function() {
      isGroupingItems = false; // always unlock before fetch so nothing stays stuck
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) { syncVisibility(cart.items); })
        .catch(function() {
          isGroupingItems = false;
          // Remove cloak on error so the drawer doesn't stay invisible
          var el = document.querySelector('[data-products]');
          if (el) el.classList.remove('bb-cloaked');
        });
    }, 60);
  }

  /* ─────────────────────────────────────────────────
     EVENT LISTENERS
     ─────────────────────────────────────────────────
     We intentionally do NOT listen to theme:cart:change
     or cart:updated.  Those events fire BEFORE Motion
     has re-rendered the drawer, so listening to them
     caused cascading /cart.js fetches:
       1. Our listener → fetchCartAndSync → /cart.js
       2. ajaxProduct:added → Motion buildCart → DOM
          mutation → MutationObserver → fetchCartAndSync
          → /cart.js (again)
       3. Motion's buildCart dispatches cart:updated
          internally → our listener (again) → /cart.js
       4. theme:cart:change retry cascade (200/500/1000ms)
          → 3 more /cart.js fetches

     Instead we rely on exactly TWO sync entry points:
       A. MutationObserver on [data-products] — fires
          once after Motion finishes buildCart()
       B. Drawer-open observer — fires when drawer opens
     Both funnel into fetchCartAndSync (60ms debounce)
     so a single action = exactly 1 /cart.js fetch.
  ───────────────────────────────────────────────── */

  // Drawer open — re-sync each time the drawer becomes visible
  var drawer = document.getElementById('CartDrawer');
  if (drawer) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          if (drawer.classList.contains('js-drawer-open') || drawer.classList.contains('is-open')) {
            fetchCartAndSync();
          }
        }
      });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Watch [data-products] — Motion replaces its innerHTML on every cart update.
  // When that happens (childList change on the container itself) we re-sync.
  var productsEl = document.querySelector('[data-products]');
  if (productsEl) {
    new MutationObserver(function(mutations) {
      if (isGroupingItems) return;
      // Ignore mutations we caused ourselves (attribute flips on hidden rows)
      var isOwnMutation = mutations.every(function(m) {
        if (m.type === 'attributes') {
          return m.target.hasAttribute('data-bb-hidden') || m.attributeName === 'data-bb-hidden';
        }
        return false;
      });
      if (isOwnMutation) return;
      // If there are active bundle items, cloak immediately before Motion finishes
      // painting so bundle rows never flash as individual items during re-renders
      // triggered by recs adds or any other cart event.
      if (bundleLineKeys.length > 0) {
        productsEl.classList.add('bb-cloaked');
        setTimeout(function() { productsEl.classList.remove('bb-cloaked'); }, 3000);
      }
      fetchCartAndSync();
    }).observe(productsEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-bb-hidden'] });
  }

  fetchCartAndSync();
})();
